import type { SupplierSalesYear } from '@tandemone/types'

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow
} from '@/components/ui/table'
import { SUPPLIER_REVENUE_RANGE_LABELS } from '@/domains/supplier-onboarding'

import { ProfileEmpty } from './profile-empty'
import { ProfileSection } from './profile-section'

export function ProfileSales({
  companyName,
  rows
}: {
  companyName: string
  rows: SupplierSalesYear[]
}) {
  return (
    <ProfileSection title={`${companyName} Sales History`}>
      {rows.length === 0 ? (
        <ProfileEmpty message='No sales history submitted.' />
      ) : (
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Year</TableHead>
              <TableHead className='text-right'>Annual revenue</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows
              .slice()
              .sort((left, right) => right.year - left.year)
              .map(row => (
                <TableRow key={row.year}>
                  <TableCell className='font-medium tabular-nums'>
                    {row.year}
                  </TableCell>
                  <TableCell className='text-right'>
                    {SUPPLIER_REVENUE_RANGE_LABELS[row.revenueRange]}
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      )}
    </ProfileSection>
  )
}
